import { useMemo } from 'react';
import { keyBy, noop } from '@adsk/alloy-react-helpers';
export default (function (dropdownProps, groupedItems) {
  let handleDisjointSelectedItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
  const {
    selectedItems,
    defaultSelectedItems,
    initialSelectedItems
  } = dropdownProps;
  return useMemo(() => {
    const getSelectedItems = itemsToFilter => {
      const items = groupedItems.flatMap(groups => groups.items);
      const itemsByValue = keyBy(items, 'value');
      const selectedItems = itemsToFilter.map(item => {
        var _itemsByValue$item$va;
        return (_itemsByValue$item$va = itemsByValue[item === null || item === void 0 ? void 0 : item.value]) !== null && _itemsByValue$item$va !== void 0 ? _itemsByValue$item$va : handleDisjointSelectedItems(item);
      });
      return selectedItems.filter(Boolean);
    };
    if (selectedItems !== undefined) {
      return {
        selectedItems: getSelectedItems(selectedItems)
      };
    }
    if (defaultSelectedItems !== undefined) {
      return {
        defaultSelectedItems: getSelectedItems(defaultSelectedItems)
      };
    }
    if (initialSelectedItems !== undefined) {
      return {
        initialSelectedItems: getSelectedItems(initialSelectedItems)
      };
    }
    return {};
  }, [selectedItems, defaultSelectedItems, initialSelectedItems, groupedItems, handleDisjointSelectedItems]);
});
//# sourceMappingURL=useSelectedItems.js.map